export enum DealerAction {
    tip = 0,
    switch = 1
}
